import React, { ComponentProps, FC, useCallback } from 'react';
import { toast } from 'react-toastify';

import Button from '@buyside/components/presentation/Button/button';

import { useRequestResearchAccessMutation } from '@interfaces/graphql-typings';

const RequestAccessButton: FC<ComponentProps<typeof Button>> = props => {
  const [requestResearchAccess, { loading }] = useRequestResearchAccessMutation();

  const handleRequestResearchAccess = useCallback(
    () =>
      requestResearchAccess()
        .then(() =>
          toast.success(
            'A representative will be in touch with you shortly regarding your inquiry.',
            {
              autoClose: 5000,
              theme: 'colored'
            }
          )
        )
        .catch(error =>
          toast.error(`An error occurred while requesting access: ${error.message}`, {
            autoClose: 5000,
            theme: 'colored'
          })
        ),
    [requestResearchAccess]
  );

  return <Button {...props} onClick={handleRequestResearchAccess} isLoading={loading} />;
};

export default RequestAccessButton;
